import { Helmet } from 'react-helmet-async';
import CampaignLeaks from 'src/sections/overview/dashboards/views/campaign-leaks';

export default function CampaignLeaksPage() {
  return (
    <>
      <Helmet>
        <title>Campaign Leaks</title>
      </Helmet>

      <CampaignLeaks />
    </>
  );
}
